import { createEvent, restore, sample } from 'effector'
import { fx } from 'src/libs'
import { PartnerEdit } from './types'
import { $params } from 'src/features/router'

export const partnerEditProfileMounted = createEvent()
export const setPartnerEditProfile = createEvent<PartnerEdit>()
export const submitEditPartner = createEvent<PartnerEdit>()

export const $partnerEditProfile = restore(setPartnerEditProfile, {
  id: '',
  status: '',
})

export const getPartner = fx<void, PartnerEdit>({
  method: 'GET',
  url: '/partner/',
})

export const updatePartner = fx<PartnerEdit, PartnerEdit>({
  method: 'PUT',
  url: '/partner/',
})

sample({
  clock: partnerEditProfileMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.partnerID
    }
    return {
      url: `/partner/${id}`,
    }
  },
  target: getPartner,
})

sample({
  clock: submitEditPartner,
  source: $params,
  fn: (params, partner) => {
    let id
    if (params) {
      id = params.partnerID
    }
    return {
      url: `/partner/${id}`,
      body: { id: partner.id, status: partner.status },
    }
  },
  target: updatePartner,
})

// update profile model

sample({
  clock: getPartner.doneData,
  fn: (doneData) => doneData.body,
  target: setPartnerEditProfile,
})
sample({
  clock: updatePartner.doneData,
  fn: (doneData) => doneData.body,
  target: setPartnerEditProfile,
})
